var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconNotesFilled(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    width: "100%",
    height: "100%",
    overflow: "visible",
    style: {
      display: "block"
    },
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Selected Icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.33333 0C2.01117 0 1.75 0.261167 1.75 0.583334V13.4167C1.75 13.7388 2.01117 14 2.33333 14H11.6667C11.9888 14 12.25 13.7388 12.25 13.4167V0.583333C12.25 0.261167 11.9888 0 11.6667 0H2.33333ZM4.08333 4.95833C3.84171 4.95833 3.64583 5.15421 3.64583 5.39583C3.64583 5.63746 3.84171 5.83333 4.08333 5.83333H7C7.24162 5.83333 7.4375 5.63746 7.4375 5.39583C7.4375 5.15421 7.24162 4.95833 7 4.95833H4.08333ZM3.64583 7.58333C3.64583 7.34171 3.84171 7.14583 4.08333 7.14583H8.75C8.99162 7.14583 9.1875 7.34171 9.1875 7.58333C9.1875 7.82496 8.99162 8.02083 8.75 8.02083H4.08333C3.84171 8.02083 3.64583 7.82496 3.64583 7.58333ZM4.08333 2.77083C3.84171 2.77083 3.64583 2.96671 3.64583 3.20833C3.64583 3.44996 3.84171 3.64583 4.08333 3.64583H8.75C8.99162 3.64583 9.1875 3.44996 9.1875 3.20833C9.1875 2.96671 8.99162 2.77083 8.75 2.77083H4.08333Z",
    fill: "var(--fill-0, white)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNotesFilled);
export default __webpack_public_path__ + "static/media/iconNotesFilled.9c1d1a89c36950130f2ac8bb850833fb.svg";
export { ForwardRef as ReactComponent };